/* eslint-disable */

// mutations
const mutations = {
  setLanguage(state, language) {
    state.language = language;
  },
  setUserData(state, data) {
    state.userData = data;
  },
  setPaxelBoxBanners(state, banners) {
    state.paxelBoxBanners = banners;
  },
  setPaxelBoxServices(state, services) {
    state.paxelBoxServices = services;
  },
  setGuestBook(state, guestBook) {
    state.guestBook = guestBook;
  },
  setAvailableLockers(state, availableLockers) {
    state.availableLockers = availableLockers;
  },
  setPackageLocker(state, packageLocker) {
    state.packageLocker = packageLocker;
  },
  setShortener(state, shortener) {
    state.shortener = shortener;
  },
  setOverdueDropOffDetail(state, overdueDropOffDetail) {
    state.overdueDropOffDetail = overdueDropOffDetail;
  },
  setOverdueDropOff(state, overdueDropOff) {
    state.overdueDropOff = overdueDropOff;
  },
  setSettings(state, settings) {
    state.settings = settings;
  },
  setOrderStatus(state, orderStatus) {
    state.orderStatus = orderStatus;
  },
  setOrderDetail(state, orderDetail) {
    state.orderDetail = orderDetail;
  },
};

export default mutations;
